import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import CountryFilter, { ShowPrice } from "../../components/CountryFilter";
import { ASSET_ENDPOINT, COURSE_SHOP_LISTING_FILTER, ENCRYPTED_KEY, fetchData, GET_SHOP_LISTING } from "../../components/Service";
import { Context } from '../../components/Context';
import { encodedText, noImageHandle } from "../../components/CommonMethod";
import { PageNavigation } from "../../components/DataTable";

const PackageList = () => {
    window.document.title = "Shop Listing Page";
    const navigate = useNavigate()
    const [currencyData, setCurrencyData] = useState({ currency_price: 1.00, currency_type: "AUD", id: 1 })
    const [courseData, setCourseData] = useState(null)
    const [listData, setListData] = useState(null);
    const [context] = useContext(Context)
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        fetchData(COURSE_SHOP_LISTING_FILTER, 'GET', '', true, false, (res) => {
            if (res.records) {
                if (res.records?.length > 0) setCourseData(res.records[0]);
            }
        })
    }, [])

    useEffect(() => {
        let user_id = context && context.auth ? context.auth.id : false
        fetchData(`${GET_SHOP_LISTING}?&user_id=${user_id}&page=${currentPage}`, 'GET', '', true, true, (res) => {
            if (res.records.data) {
                setListData(res.records.data)
            } else {
                setListData({ data: [] });
            }
        });
    }, [context, currentPage]);

    const instanceCheckout = (e, item) => {
        e.preventDefault()
        navigate(`/checkout?checkout_id=${encodedText(item.id, ENCRYPTED_KEY)}`)
    }

    return (<>

        <section className="py-4 py-sm-5">
            <div className="container container-1180">
                <div className="row">
                    <div className="col-lg-11 mx-auto">
                        <div className="d-lg-flex justify-content-between">
                            <div className="d-flex justify-content-between mb-4 mb-md-3 order-1">
                                <CountryFilter currencyData={currencyData} setCurrencyData={setCurrencyData} />
                            </div>
                            <div className="d-flex flex-wrap align-items-baseline justify-content-between fw-bold mb-3 me-1" id="button_lineheigh">
                                <div className="d-flex align-items-center mb-3 order-sm-0 order-1">
                                    <h3 className="align-items-center fw-bold mb-0 order-sm-0  h2">NSW Grade 11 and 12 Chemistry Interactive Study Guides</h3>
                                </div>
                            </div>
                        </div>
                        {listData?.data && <>
                            {listData?.data?.length > 0 ? listData.data.map((item, key) => {
                                return (
                                    <Link to={`/shop-details/${encodedText({ id: item.id }, ENCRYPTED_KEY)}`} key={key} className="text-decoration-none text-dark">
                                        <div className="card border-blue-hover rounded-4 mb-4">
                                            <div className="card-body p-md-4 d-md-flex">
                                                <div className="shadow-md rounded-3 overflow-hidden me-3 me-md-4 mmwh-215">
                                                    <img src={item.image ? ASSET_ENDPOINT + item.image : '../images/ionic-purple.jpg'} className="h-100 ratio w-100 hm-180 object-fit-cover" alt={item.title} onError={noImageHandle} />
                                                </div>
                                                <div className="d-block flex-grow-1 flex-1 d-sm-flex mt-3 mt-md-0">
                                                    <div className="pe-sm-4 flex-1">
                                                        <h3 className="fw-bold h3 listing-heading">{item.title} {item.type !== 'single' ? '' : ''}</h3>
                                                        <div className="d-flex flex-wrap gap-3 mb-3 pt-1 listing-small-text">
                                                            <div className="d-inline-flex fs-18 me-1" >
                                                                <div className="mmwh-30 text-white d-flex justify-content-center align-items-center rounded-circle me-2" style={{ background: `hsl(270, 100%, 50%)` }}>
                                                                    <svg className="icon ts-1p1"><use href="#icon_help"></use></svg>
                                                                </div>
                                                                <span className="fw-bold">Practise questions</span>
                                                            </div>
                                                            <div className="d-inline-flex fs-18 me-1">
                                                                <div className="mmwh-30 text-white d-flex justify-content-center align-items-center rounded-circle me-2" style={{ background: `hsl(120, 100%, 50%)` }}>
                                                                    <svg className="icon ts-1p1"><use href="#icon_books"></use></svg>
                                                                </div>
                                                                <span className="fw-bold">Super engaging videos and lessons</span>
                                                            </div>
                                                            {!(item.grade === 'Grade 11') && <>
                                                                <div className="d-inline-flex fs-18 me-1">
                                                                    <div className="mmwh-30 text-white d-flex justify-content-center align-items-center rounded-circle me-2" style={{ background: `hsl(200, 100%, 50%)` }}>
                                                                        <svg className="icon ts-1p1"><use href="#icon_graystar"></use></svg>
                                                                    </div>
                                                                    <span className="fw-bold">HSC exam style questions</span>
                                                                </div>
                                                            </>}
                                                        </div>
                                                    </div>
                                                    <div className="ms-auto text-sm-end d-flex flex-column min-w-200 gap-3 mt-3 mt-sm-0 pb-2">
                                                        <h4 className="fw-bold mb-0"><ShowPrice currencyData={currencyData} price={item.price} /></h4>
                                                        <div className="mt-auto d-flex flex-sm-column align-items-end gap-3">
                                                            {context?.auth ? context?.auth?.user_type === '2' && <>
                                                                {context.auth.group_details ? <p className="fw-bold text-green mb-0">You are a group student.</p> : <>
                                                                    {/* <Link to={`/shop-details/${encodedText({ id: item.id, is_purchased: item.is_purchased }, ENCRYPTED_KEY)}`} className="btn btn-green pe-none btn-lg text-nowrap mt-2" title="Try Now" style={{ cursor: 'default' }} onClick={(e) => e.preventDefault()}>Try Now</Link> */}
                                                                    {item.is_purchased ? <button type="button" className={`btn btn-yellow btn-lg text-nowrap`} title="Purchased" >Purchased</button> : <button type="button" className={`btn btn-theme-primary btn-lg text-nowrap`} title="Get Access Now" onClick={(e) => instanceCheckout(e, item)}>Get Access Now</button>}
                                                                </>}
                                                            </> : <>
                                                                {/* <Link to={`/shop-details/${encodedText(item.id, ENCRYPTED_KEY)}`} className="btn btn-yellow pe-none btn-lg text-nowrap mt-2" title="Try Now" style={{ cursor: 'default' }} onClick={(e) => e.preventDefault()}>Try Now</Link> */}
                                                                <button type="button" className="btn btn-theme-primary btn-lg text-nowrap" title="Get Access Now" onClick={(e) => instanceCheckout(e, item)}>Get Access Now</button>
                                                            </>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            }) : <div className="row mt-1"><h4 className="fw-bold my-3 text-danger text-center">Workbook Not Found</h4></div>}
                        </>}
                        {listData?.recordsTotal > 0 && <PageNavigation active_page={currentPage - 1} per_page={10} filter_recoards={listData.recordsFiltered.length} setCurrentPage={setCurrentPage} />}
                    </div>
                </div>
            </div>
        </section>
    </>)
}
export default PackageList;